import { useTranslation } from 'react-i18next';

import { useMutation, useQuery } from '@tanstack/react-query';

import { getKeyByValue } from '../utils/utils';

import { getApi, postApi } from './utils/utils';

import { LANGUAGES } from 'constants/languages';

export const COMPANY_NAME = 'ZOGOFARM';
export const useHomeCorausel = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['home-corausel', currentLanguage],
    queryFn: () => {
      return getApi(`/user/asset/inventory?limit=100`);
    },
    onSuccess: () => {},
  });
};

export const useTopPairInventory = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['top-pair', currentLanguage],
    queryFn: () => {
      return getApi(`/user/pair/inventory`);
    },
    onSuccess: () => {},
  });
};

export const useMineMutate = () => {
  return useMutation({
    mutationKey: 'mine-mutate',
    mutationFn: (data) => {
      return postApi('/user/asset/mine', data);
    },
    onSuccess: (data) => {
      console.log({ data });
    },
  });
};

export const useRepairMutate = () => {
  return useMutation({
    mutationKey: 'repair-mutate',
    mutationFn: (data) => {
      return postApi('/user/asset/repair', data);
    },
    onSuccess: (data) => {
      console.log({ data });
    },
  });
};
